let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ivX4B")).then(() => parcelRequire('8sv7q'));